module.exports = __webpack_public_path__ + "img/arrow-orange.d78a47d0.svg";